import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { actions as authActions } from "store/authRedux/actions";
import { actions as commonActions } from "store/commonRedux/actions";
import { GetUserByToken } from "services/account";

const IMPERSONATE_DURATION = 15 * 60 * 1000;

const ImpersonateHandler = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const url = new URL(window.location.href);
    const impersonateToken = url.searchParams.get("impersonate");
    if (!impersonateToken) return;

    // Clean the token from URL immediately
    url.searchParams.delete("impersonate");
    window.history.replaceState({}, "", url.pathname + (url.search || ""));

    const setup = async () => {
      // Log out any existing session and reset channel/onboarding state
      dispatch(authActions.logout());
      dispatch(commonActions.resetUserVariables());

      // Put token in store so the API interceptor picks it up
      dispatch(authActions.impersonateLogin(impersonateToken));

      try {
        const user = await GetUserByToken();
        dispatch(authActions.setUser(user));
      } catch {
        dispatch(authActions.logout());
        return;
      }

      setTimeout(() => {
        dispatch(authActions.logout());
      }, IMPERSONATE_DURATION);
    };

    setup();
  }, []);

  return null;
};

export default ImpersonateHandler;
